import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { QbInputModule } from '@fwmovilidad/qb-lib-ng-components';
import { QbPostalCodeMultiComponent } from './postal-code-multi.component';

@NgModule({
  imports: [CommonModule, FormsModule, ReactiveFormsModule, QbInputModule],
  declarations: [QbPostalCodeMultiComponent],
  exports: [QbPostalCodeMultiComponent],
})
export class QbPostalCodeMultiModule { }